export default "__VITE_ASSET__DVBhWCmT__"